var _NativeModules$Cookie;
import { NativeModules, Platform } from 'react-native';
const cookie = Platform.OS === 'web' ? document.cookie : NativeModules === null || NativeModules === void 0 ? void 0 : (_NativeModules$Cookie = NativeModules.CookieManager) === null || _NativeModules$Cookie === void 0 ? void 0 : _NativeModules$Cookie.getCookie('');
export const getCookie = name => {
  var _cookie$split;
  const cookieObj = {};
  cookie === null || cookie === void 0 ? void 0 : (_cookie$split = cookie.split(';')) === null || _cookie$split === void 0 ? void 0 : _cookie$split.map(item => {
    const arr = item.split('=');
    if (arr.length > 1) {
      var _arr$, _arr$$trim;
      const key = arr === null || arr === void 0 ? void 0 : (_arr$ = arr[0]) === null || _arr$ === void 0 ? void 0 : (_arr$$trim = _arr$.trim) === null || _arr$$trim === void 0 ? void 0 : _arr$$trim.call(_arr$);
      const value = arr === null || arr === void 0 ? void 0 : arr[1];
      cookieObj[key] = value;
    }
  });
  return cookieObj[name] || '';
};